import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { registerUser } from '../../../api/user/auth';
import styles from './Auth.module.css'; 

const Register = () => {
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    confirm_pass: '',
  });

  const navigate = useNavigate();

  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    console.log(formData);

    try {
      const response = await registerUser(formData)

      console.log('Registration response:', response);

      if(!response.success){
        setError(response.message);
        return; // ADD RETURN HERE TO STOP EXECUTION
      }
      
      console.log('Registration successful', response);

      // Only navigate if registration was successful
      navigate(`/verify-email/${response.user._id}`)

    } catch (error) {
      console.error('Registration error:', error);
      setError(error.message || 'Registration failed');
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      <div className={styles.authContainer}>
        <div className={styles.backgroundAnimation}></div>
        
        <div className={`${styles.authCard} ${styles.userCard}`}>
          <div className={styles.authHeader}>
            <div className={styles.authLogo}>SPOTFLI</div>
            <h2 className={styles.authTitle}>Create Your Account</h2>
            <p className={styles.authSubtitle}>Join thousands of users discovering amazing properties</p>
          </div>

          {error && (
            <div className={styles.errorMessage}>
              <i className={`fa fa-exclamation-circle ${styles.errorIcon}`}></i>
              {error}
            </div>
          )}

          <form className={styles.authForm} onSubmit={handleSubmit}>
            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <label className={styles.formLabel} htmlFor="first_name">First Name</label>
                <input 
                  className={styles.formInput}
                  type="text" 
                  name='first_name' 
                  value={formData.first_name} 
                  id='first_name' 
                  onChange={handleChange} 
                  placeholder='Enter your first name' 
                  required
                />
              </div>
              
              <div className={styles.formGroup}>
                <label className={styles.formLabel} htmlFor="last_name">Last Name</label>
                <input 
                  className={styles.formInput}
                  type="text" 
                  name='last_name' 
                  value={formData.last_name} 
                  id='last_name' 
                  onChange={handleChange} 
                  placeholder='Enter your last name' 
                  required
                />
              </div>
            </div>

            <div className={styles.formGroup}>
              <label className={styles.formLabel} htmlFor="email">Email Address</label>
              <input 
                className={styles.formInput}
                type="email" 
                name='email' 
                value={formData.email} 
                onChange={handleChange} 
                placeholder='your.email@example.com' 
                required
              />
            </div>

            {/* <div className={styles.formGroup}>
              <label className={styles.formLabel}>Gender</label>
              <div className={styles.genderGroup}>
                <label className={styles.genderOption}>
                  <input type="radio" name='gender' value="male" onChange={handleChange} />
                  Male
                </label>
                <label className={styles.genderOption}>
                  <input type="radio" name='gender' value="female" onChange={handleChange} />
                  Female
                </label>
              </div>
            </div>

            <div className={styles.formGroup}>
              <label className={styles.formLabel} htmlFor="dob">Date of Birth</label>
              <input 
                className={styles.formInput}
                type="date" 
                name='dob' 
                value={formData.dob} 
                onChange={handleChange} 
                required
              />
            </div> */}

            <div className={styles.formGroup}>
              <label className={styles.formLabel} htmlFor="password">Password</label>
              <div className={styles.passwordInputContainer}>
                <input 
                  className={styles.formInput}
                  type={showPassword ? "text" : "password"}
                  name='password' 
                  value={formData.password} 
                  onChange={handleChange} 
                  placeholder='Create a strong password' 
                  required
                />
                <button 
                  type="button" 
                  className={styles.passwordToggle}
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  <i className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                </button>
              </div>
            </div>

            <div className={styles.formGroup}>
              <label className={styles.formLabel} htmlFor="confirm_pass">Confirm Password</label>
              <div className={styles.passwordInputContainer}>
                <input 
                  className={styles.formInput}
                  type={showConfirmPassword ? "text" : "password"}
                  name='confirm_pass' 
                  value={formData.confirm_pass} 
                  onChange={handleChange} 
                  placeholder='Confirm your password' 
                  required
                />
                <button 
                  type="button" 
                  className={styles.passwordToggle}
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  aria-label={showConfirmPassword ? "Hide password" : "Show password"}
                >
                  <i className={`fa ${showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                </button>
              </div>
            </div>

            <div className={styles.termsGroup}>
              <input type="checkbox" required /> 
              <span className={styles.termsText}>
                I agree to SPOTFLI's <Link to="/terms-conditions" className={styles.termsLink}>Terms and Conditions </Link>
              </span>
            </div>

            <button 
              className={styles.authButton} 
              type='submit' 
              disabled={isLoading}
            >
              {isLoading ? 'Creating Account...' : 'Create Account'}
            </button>

            <div className={styles.authLinks}>
              <span>Already have an account? </span>
              <Link to="/login" className={styles.authLink}>Sign In</Link>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}

export default Register;